import { useEffect, useState } from "react";
import { fetchMeterDetailsAsync } from "../actions/meters.actions";
import { useErrorHandler } from "./useErrorHandler";
import { MeterDetailsType } from "../types";

export default function useMeterDetails(meterSerialNo: string) {
  const { handleError } = useErrorHandler();

  const [loading, setLoading] = useState(false);
  const [meterDetails, setMeterDetails] = useState<MeterDetailsType | null>(
    null
  );

  const fetchMeterDetails = () => {
    setLoading(true);

    fetchMeterDetailsAsync(meterSerialNo)
      .then((res: any) => {
        if (res?.data?.meterSerialNo) {
          setMeterDetails(res?.data);
        } else {
          setMeterDetails(null);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        handleError(error);
      });
  };

  useEffect(() => {
    if (meterSerialNo) {
      fetchMeterDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meterSerialNo]);

  return {
    meterDetails,
    loading,
  };
}
